export const ADDON_LIST = 'ADDON_LIST';
export const STRAW_LIST = 'STRAW_LIST';